import tStatic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic'

/**
 * Словесная оценка по `avg_rate`.
 *
 * Шкала вокруг нуля, не 1–5.
 * Цвет звёзд грубее (три состояния), слова дробят тот же диапазон на пять подписей.
 */
export default function getStarsLabel(avgRate: number): string {
  if (avgRate <= -1.2) {
    return tStatic('Ужасно')
  }

  if (avgRate < -0.4) {
    return tStatic('Плохо')
  }

  if (avgRate <= 0.4) {
    return tStatic('Нормально')
  }

  if (avgRate < 1.2) {
    return tStatic('Хорошо')
  }

  return tStatic('Отлично')
}

/**
 * BEM-модификатор цвета звёзд.
 *
 * Для «нормально» класс пустой: нейтральный цвет задаёт блок без модификатора.
 */
export function getStarsModifier(avgRate: number): string {
  if (avgRate < -0.4) {
    return 'review-card-tooltips__stars--negative'
  }

  if (avgRate > 0.4) {
    return 'review-card-tooltips__stars--positive'
  }

  return ''
}
